import { useMemo } from 'react';
import get from 'lodash/get';
import has from 'lodash/has';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import {
	useAnalyticsEvents,
	fireTrackAnalytics,
	fireOperationalAnalytics,
	type AnalyticsAttributes,
} from '@atlassian/jira-product-analytics-bridge';
import type { ErrorResponse } from '@atlassian/jira-servicedesk-common/src/utils/fetch';
import { ERROR_STATE_REVERT_PATH } from '../../common/constants';

const useTracking = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useMemo(
		() => ({
			fireError: (id: string, error: ErrorResponse, attributes?: AnalyticsAttributes): void => {
				const errorAttributes = has(error, ERROR_STATE_REVERT_PATH)
					? { ...attributes, stateReverted: get(error, ERROR_STATE_REVERT_PATH) }
					: attributes;

				fireErrorAnalytics({
					meta: {
						id,
						packageName: 'jiraServicedeskPortalSettingsRequestGroups',
						teamName: 'jsd-shield',
					},
					error: new Error(get(error, 'response.errors[0].errorMessage', id)),
					event: createAnalyticsEvent({}),
					attributes: errorAttributes,
					sendToPrivacyUnsafeSplunk: true,
				});
			},
			fireTrack: (actionSubject: string, attributes: AnalyticsAttributes = {}): void => {
				fireTrackAnalytics(createAnalyticsEvent({}), actionSubject, attributes);
			},
			fireOperational: (actionSubject: string, attributes: AnalyticsAttributes = {}): void => {
				fireOperationalAnalytics(createAnalyticsEvent({}), actionSubject, attributes);
			},
		}),
		[createAnalyticsEvent],
	);
};

export default useTracking;
